import axiosInstance from "../utils/axios";

const pathPrefix = `${process.env.REACT_APP_SERVER_URL}/api`;

export interface IYouTrackProjectOption {
  id: string;
  shortName: string;
  name: string;
}

export function getYouTrackProjects(): Promise<IYouTrackProjectOption[]> {
  return axiosInstance
    .get<IYouTrackProjectOption[]>(`${pathPrefix}/youtrack/projects`)
    .then((response) => response.data);
}
